import React from "react";
import IdNameModel from "../../../models/common/IdNameModel";
import VendorSubUserRequestModel from "../../../models/company/vendorUser/request/VendorSubUserRequestModel";
import JobPostingVendorsGridComponent from "./JobPostingVendorsGridComponent";
import { useForm, Controller } from "react-hook-form";
import JobPostingVendorRequestModel from "../../../models/company/jobPosting/request/JobPostingVendorRequestModel";
import { GuidEnum } from "../../../models/enums/GuidEnum";
import { FORM_SELECT_RULE } from "../../../utils/validation-utils";
import toasterUtils from "../../../utils/toaster-utils";
import { Autocomplete, Button, FormControl, FormHelperText, InputLabel, MenuItem, Select, TextField } from "@mui/material";

interface JobPostingVendorProps {
    requirementVendors: VendorSubUserRequestModel[];
    vendorForRequiremrntList: IdNameModel[];
    requirementId: string;
    onVendorSave: (objVendor: JobPostingVendorRequestModel) => void;
    onCloseVendor: () => void;
};
const JobPostingVendorsComponent = (props: JobPostingVendorProps) => {
    const {
        register,
        control,
        handleSubmit,
        formState: { errors, isValid },
    } = useForm<JobPostingVendorRequestModel>({
        mode: "onChange"
    });

    const onSubmit = (formData: JobPostingVendorRequestModel) => {
        if (!isValid) {
            toasterUtils.showError("Please fill all mandatory fields");
            return;
        }
        formData.requirementId = props.requirementId;
        formData.userId = GuidEnum.Empty;
        props.onVendorSave(formData);
    }

    return (
        <div className="card card-white">
            <div className="card-body">
                <form className="contact quform" onSubmit={handleSubmit(onSubmit)}>
                    <div className="row">
                        <div className="col-md-6 mt-1">
                            <Controller name="vendorId" control={control} defaultValue={GuidEnum.Empty} rules={FORM_SELECT_RULE}
                                render={({ field }) => (
                                    <Autocomplete {...field} value={props.vendorForRequiremrntList.find(x => x.guId === field.value) || null}
                                        onChange={(_, newValue) => field.onChange(newValue ? newValue.guId : GuidEnum.Empty)} options={props.vendorForRequiremrntList} getOptionLabel={(option) => option.name || ""}
                                        renderInput={(params) => (
                                            <TextField {...params} label="Vendor" size="small" required margin="normal" fullWidth error={!!errors.vendorId} helperText={errors.vendorId?.message} />
                                        )}
                                        isOptionEqualToValue={(option, value) => option.guId === value.guId}
                                    />
                                )}
                            />
                        </div>
                        <div className="col-md-6 mt-4">
                            <Button variant="contained" color="success" type="submit" disabled={!isValid}>
                                Save
                            </Button>
                            <Button variant="contained" color="error" className="m-l-xxs" type="button" onClick={props.onCloseVendor}>
                                Close
                            </Button>
                        </div>
                    </div>
                </form>
                <JobPostingVendorsGridComponent
                    vendorList={props.requirementVendors} />
            </div>
        </div>
    );
};
export default JobPostingVendorsComponent;